"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAgreementRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "serviceAgreementId",
                type: "uint256",
            },
        ],
        name: "ClosedAgreementCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "serviceAgreementId",
                type: "uint256",
            },
        ],
        name: "ClosedAgreementRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "UserAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "UserRemoved",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "establisher",
                type: "address",
            },
        ],
        name: "addEstablisher",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "addUser",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "clearAllEndedAgreements",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "clearEndedAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "closedServiceAgreementExpired",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "closedServiceAgreementIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "consumerAuthAllows",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "consumer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "lockedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startDate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planTemplateId",
                        type: "uint256",
                    },
                ],
                internalType: "struct ClosedServiceAgreementInfo",
                name: "agreement",
                type: "tuple",
            },
        ],
        name: "createClosedServiceAgreement",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "establishServiceAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "establisherWhitelist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "getClosedServiceAgreement",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "consumer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "lockedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startDate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "planTemplateId",
                        type: "uint256",
                    },
                ],
                internalType: "struct ClosedServiceAgreementInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "hasOngoingClosedServiceAgreement",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "indexerCsaLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "indexerDeploymentCsaLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_whitelist",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nextServiceAgreementId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "establisher",
                type: "address",
            },
        ],
        name: "removeEstablisher",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "consumer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "removeUser",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "renewAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "setSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "setThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "sumDailyReward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "threshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ServiceAgreementRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "ServiceAgreementRegistry";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ServiceAgreementRegistry__factory = ServiceAgreementRegistry__factory;
ServiceAgreementRegistry__factory.bytecode = _bytecode;
ServiceAgreementRegistry__factory.abi = _abi;
